<div class="client-dashboard-container">
    <div class="title" *ngIf="!selectedUserRole && isDisplayClientDashboard">
        Dashboard
    </div>
    
    <!-- Trial Status Information -->
    <div *ngIf="companyDetails && companyDetails.is_trial && !selectedUserRole && !isDisplayClientDashboard" class="trial-status-card">
        <mat-card [ngClass]="{'trial-warning': shouldShowTrialWarning(), 'trial-info': !shouldShowTrialWarning(), 'trial-expired': isTrialExpired()}">
            <mat-card-content>
                <div class="trial-status-content">
                    <div class="trial-status-left">
                        <div class="trial-icon-wrapper" [ngClass]="{'warning-wrapper': shouldShowTrialWarning(), 'info-wrapper': !shouldShowTrialWarning(), 'expired-wrapper': isTrialExpired()}">
                            <mat-icon [ngClass]="{'warning-icon': shouldShowTrialWarning(), 'info-icon': !shouldShowTrialWarning(), 'expired-icon': isTrialExpired()}">
                                {{ isTrialExpired() ? 'schedule' : (shouldShowTrialWarning() ? 'warning_amber' : 'info_outline') }}
                            </mat-icon>
                        </div>
                        <div class="trial-text">
                            <h3 class="trial-title">
                                {{ getTrialStatusMessage() }}
                            </h3>
                            <p class="trial-subtitle">
                                {{ getTrialSubtitleMessage() }}
                            </p>
                            
                            <!-- Progress Bar for Client Usage (only show if not expired) -->
                            <div class="trial-progress" *ngIf="!isTrialExpired()">
                                <div class="progress-bar">
                                    <div class="progress-fill" 
                                         [ngClass]="{'warning-progress': shouldShowTrialWarning(), 'info-progress': !shouldShowTrialWarning()}"
                                         [style.width.%]="(currentClientCount / companyDetails.trial_client_limit) * 100">
                                    </div>
                                </div>
                                <div class="progress-text">
                                    {{ currentClientCount }} / {{ companyDetails.trial_client_limit }} clients used
                                    <span *ngIf="!shouldShowTrialWarning()">
                                        • {{ companyDetails.trial_client_limit - currentClientCount }} remaining
                                    </span>
                                </div>
                            </div>

                            <!-- Trial Days Information -->
                            <div class="trial-days-info" *ngIf="companyDetails.trial_limit_days && !isTrialExpired()">
                                <div class="days-info-text" [ngClass]="{'warning-days': getRemainingTrialDays() <= 3}">
                                    <mat-icon class="small-icon">schedule</mat-icon>
                                    {{ getRemainingTrialDays() }} of {{ companyDetails.trial_limit_days }} days remaining in trial
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="trial-status-right">
                        <div class="trial-stats">
                            <div class="stats-number" [ngClass]="{'warning-number': shouldShowTrialWarning(), 'info-number': !shouldShowTrialWarning(), 'expired-number': isTrialExpired()}">
                                {{ isTrialExpired() ? 0 : (isTrialLimitReached() ? 0 : getTrialStatsNumber()) }}
                            </div>
                            <div class="stats-label">
                                {{ isTrialExpired() ? 'Expired' : getTrialStatsLabel() }}
                            </div>
                        </div>
                        <button mat-raised-button 
                                class="upgrade-button"
                                [ngClass]="{'warning-button': shouldShowTrialWarning(), 'info-button': !shouldShowTrialWarning(), 'expired-button': isTrialExpired()}"
                                (click)="navigateToBilling()">
                            <mat-icon>{{ (isTrialExpired() || shouldShowTrialWarning()) ? 'upgrade' : 'visibility' }}</mat-icon>
                            {{ (isTrialExpired() || shouldShowTrialWarning()) ? 'Upgrade Now' : 'View Plans' }}
                        </button>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
    
    <div>
        <div *ngIf="isDisplayClientDashboard">
            <div class="progress">
                <div class="col-50">
                    <span class="goal-progress">Goal Progress</span> <span class="sessions" *ngIf="isDisplayClientDashboard && isDashboardLoaded && errorMsg.length === 0">{{dashboardData.weeksNow}} /
                        {{dashboardData.goal.weekstogoal}} Sessions</span>
                </div>
                <div class="col-50 col-date-picker">
                    <mat-form-field appearance="fill">
                        <div (click)="picker.open()" class="today-lbl" [style.display]="isTodayDate ? 'block' : 'none'">
                            Today</div>
                        <input [style.display]="!isTodayDate ? 'block' : 'none'" matInput [matDatepicker]="picker"
                            (focus)="picker.open()" [readonly]="true" [max]="maxDate" (dateChange)="onDateSelect($event)"
                            [formControl]="goalsDate">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div *ngIf="!isDisplayClientDashboard">
            <mat-card>
                <section class="dashboardSection">
                    <ng-container *ngIf="companyDetails && companyDetails.dashboard_image; else fallbackImages">
                        <img [src]="companyDetails.dashboard_image" alt="Dashboard Image">
                    </ng-container>
                    <ng-template #fallbackImages>
                        <ng-container *ngIf="companyUrl == 'fitness'; else elseBlock">
                            <img src="assets/iStock.jpg" alt="Image One">
                        </ng-container>
                        <ng-template #elseBlock>
                            <img src="/assets/THFHome.png" alt="Fitness Image">
            
                        </ng-template>
                    </ng-template>
                </section>
            </mat-card>
        </div>
        <div *ngIf="errorMsg.length > 0" class="err-info">
            <mat-card>{{errorMsg}}</mat-card>
        </div>
        <div *ngIf="isDisplayClientDashboard && isDashboardLoaded && errorMsg.length === 0">
            <div class="composition">
                <mat-card>
                    <div>
                        <div class="lbl-composition">
                            Composition
                        </div>
                        <div class="col">
                            <div class="col-50">
                                <div class="card-title">Weight</div>
                                <div class="card-value">{{dashboardData.weights[0].weight}}</div>
                                <div>
                                    <mat-icon class="success-info success-icon" *ngIf="dashboardData.weightsDiffer < 0">
                                        arrow_downward</mat-icon>
                                    <mat-icon class="error-info success-icon" *ngIf="dashboardData.weightsDiffer > 0">
                                        arrow_upward</mat-icon> <span 
                                        [ngClass]="{'error-info': dashboardData.weightsDiffer > 0,'success-info info-label': dashboardData.weightsDiffer < 0}">{{dashboardData.weightsDiffer}}
                                        lbs</span> <span class="since-start">Since Start</span>
                                </div>
                            </div>
                            <div class="col-50">
                                <highcharts-chart [Highcharts]="highcharts" [options]="dashboardWeightChartOptions"
                                    [(update)]="updateNutritionFlag" style="width: 100%; height: 100px; display: block;">
                                </highcharts-chart>
                            </div>
                        </div>
                        <div class="col">
                            <div class="col-50">
                                <div class="card-title">Body Fat</div>
                                <div class="card-value">{{dashboardData.weights[0].bodyfat}}%</div>
                                <div>
                                    <mat-icon class="success-info success-icon" *ngIf="dashboardData.bodyfatDiffer < 0">
                                        arrow_downward</mat-icon>
                                    <mat-icon class="error-info success-icon" *ngIf="dashboardData.bodyfatDiffer > 0">
                                        arrow_upward</mat-icon> <span 
                                        [ngClass]="{'error-info': dashboardData.bodyfatDiffer > 0,'success-info info-label': dashboardData.bodyfatDiffer < 0}">{{dashboardData.bodyfatDiffer}}
                                        %</span> <span class="since-start">Since Start</span>
                                </div>
                            </div>
                            <div class="col-50">
                                <highcharts-chart [Highcharts]="highcharts" [options]="dashboardBodyFatChartOptions"
                                    [(update)]="updateNutritionFlag" style="width: 100%; height: 100px; display: block;">
                                </highcharts-chart>
                            </div>
                        </div>
                        <div class="col">
                            <div class="col-50">
                                <div class="card-title">Muscle Mass</div>
                                <div class="card-value">{{commonService.getFixedValue(dashboardData.weights[0].leanmuscle)}}</div>
                                <div>
                                    <mat-icon class="success-info success-icon" *ngIf="dashboardData.musclemassDiffer < 0">
                                        arrow_downward</mat-icon>
                                    <mat-icon class="error-info success-icon" *ngIf="dashboardData.musclemassDiffer > 0">
                                        arrow_upward</mat-icon> <span
                                        [ngClass]="{'error-info': dashboardData.musclemassDiffer > 0,'success-info info-label': dashboardData.musclemassDiffer < 0}">{{dashboardData.musclemassDiffer}}
                                        lbs</span> <span class="since-start">Since Start</span>
                                </div>
                            </div>
                            <div class="col-50">
                                <highcharts-chart [Highcharts]="highcharts" [options]="dashboardLeanMuscleChartOptions"
                                    [(update)]="updateNutritionFlag" style="width: 100%; height: 100px; display: block;">
                                </highcharts-chart>
                            </div>
                        </div>
                    </div>
                </mat-card>
            </div>
            <div class="composition-info">
                <div class="col">

                    <mat-card class="info-card">
                        <div class="dashboard-title">
                            <div class="card-title">Nutrition</div>
                           <a (click)="navugateToClientPage('nutrition')" *ngIf="isConsultantView">View active plan</a>
                        </div>
                        <div>
                            <highcharts-chart [Highcharts]="highcharts" [options]="nutritionChartOptions"
                                [(update)]="updateNutritionFlag" style="width: 100%; height: 300px; display: block;">
                            </highcharts-chart>
                        </div>
                    </mat-card>
                </div>
                <div class="col">
                    <mat-card class="info-card calories-info">
                        <div class="card-title">Calories</div>
                        <div class="cal-center">
                            <circle-progress
                                [percent]="commonService.getPercentageValue(dashboardData.nutrition.calories.consumed, dashboardData.nutrition.calories.total)"
                                [title]="commonService.roundValues(dashboardData.nutrition.calories.consumed).toString()"
                                titleFontSize="40" titleFontWeight="700" titleColor="#11101D" [showSubtitle]="false"
                                [radius]="100" [animation]="true" [animationDuration]="300">
                            </circle-progress>
                        </div>
                        <div class="goal-info">
                            Goal: {{commonService.roundValues(dashboardData.nutrition.calories.total)}}
                        </div>
                    </mat-card>
                </div>
                <div class="col">
                    <mat-card class="info-card">
                        <div class="dashboard-title">
                            <div class="card-title">Exercise Progress</div>
                            <a (click)="navugateToClientPage('exercise')" *ngIf="isConsultantView">View active plan</a>
                        </div>
                        <div *ngFor="let item of exerciseData; let i = index" class="percent-exercise" [@fadeInUp]="{value: ':enter', params: {delay: i * 100}}">
                            <div class="exercise-info">
                                <span class="exe-title">{{item.title}}</span>
                                <span class="actual_total">{{item.actual}}/{{item.total}}</span>
                            </div>
                            <mat-progress-bar mode="determinate" [value]="item.percent" 
                                            [class.animate]="item.percent > 0">
                            </mat-progress-bar>
                        </div>
                    </mat-card>
                </div>
            </div>
        </div>
    </div>
</div>